import { ReactComponent as IconAdd } from 'assets/icon/ico_add.svg'
import STYLE_GUIDE from 'shared/constants/color'
import styled from 'styled-components'

const MoreButton = (props) => {
  const { onClick, disabled } = props

  return (
    <MoreButtonWrap onClick={onClick} disabled={disabled}>
      더보기
      <IconAdd />
    </MoreButtonWrap>
  )
}

export default MoreButton

const MoreButtonWrap = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
  gap: 10px;
  padding: 20px 30px;
  width: fit-content;
  border: 1.5px solid ${STYLE_GUIDE.COLOR.black3};
  border-radius: 120px;
  color: ${STYLE_GUIDE.COLOR.black1};
  font-size: 24px;
  font-weight: 700;
  line-height: 36px;
  cursor: pointer;

  &:active {
    border: 1.5px solid ${STYLE_GUIDE.COLOR.black4};
    background: ${STYLE_GUIDE.COLOR.gray5};
    color: ${STYLE_GUIDE.COLOR.black4};
  }

  @media screen and (max-width: 1199px) {
    gap: 4px;
    padding: 6px 16px;
    border: 1px solid ${STYLE_GUIDE.COLOR.black3};
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;

    & > svg {
      width: 12px;
      height: 12px;
    }
  }
`
